
export default () => ({
    save: false
})